var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustpilotReviewsMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93f9ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27768,
    stopColor: "#42e7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#03da8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#036d61"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.92102,26.06866h-35.84198c-3.96857,0-7.19757,3.22852-7.19757,7.19708v25.2135c0,3.96857,3.229,7.19708,7.19757,7.19708h9.68976v4.0769h-4.90228c-2.3075,0-4.1781,1.87061-4.1781,4.17804h34.62311c0-2.30743-1.87061-4.17804-4.17804-4.17804h-4.90228v-4.0769h9.68982c3.96857,0,7.19757-3.22852,7.19757-7.19708v-25.2135c0-3.96857-3.229-7.19708-7.19757-7.19708ZM70.36444,58.47925c0,1.34729-1.09613,2.44293-2.44342,2.44293h-35.84198c-1.34735,0-2.44348-1.09564-2.44348-2.44293v-25.2135c0-1.34729,1.09613-2.44299,2.44348-2.44299h35.84198c1.34729,0,2.44342,1.0957,2.44342,2.44299v25.2135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,36.862c-8.76129,0-15.86371,9.0105-15.86371,9.0105,0,0,7.10242,9.0105,15.86371,9.0105s15.86365-9.0105,15.86365-9.0105c0,0-7.10242-9.0105-15.86365-9.0105ZM50,52.68042c-3.75995,0-6.80792-3.04803-6.80792-6.80792s3.04797-6.80792,6.80792-6.80792,6.80786,3.04803,6.80786,6.80792-3.04791,6.80792-6.80786,6.80792Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustpilotReviewsMonitoring);
export default __webpack_public_path__ + "static/media/trustpilot-reviews-monitoring.f71f262e66c8f377159fb49c6bb4499a.svg";
export { ForwardRef as ReactComponent };